import { Switch, Route, useRouteMatch } from 'react-router-dom';

import BotExploreHeader from 'components/explore/BotExploreHeader';
import BotContent from './BotContent';
import AddBotPage from './AddBotPage';

const BotPage = () => {
  const { params, url, path } = useRouteMatch();
  const { botId } = params;

  const backUrl = {
    pathname: url,
  };

  return (
    <>
      <BotExploreHeader botId={botId} />

      <div className="container pb-5">
        <BotContent />
      </div>

      <Switch>
        <Route exact path={`${path}/bots/add`} children={<AddBotPage backUrl={backUrl} botId={botId} />} />
      </Switch>
    </>
  );
};

export default BotPage;
